import React from "react";
import PropTypes from "prop-types";
import { Image } from "@sparefoot/react-commons";
import { useSelector } from "react-redux";
import classnames from "classnames";
import { H2, Paragraph } from "components/core/Typography";
import { SearchBar } from "components/search/SearchBar";
import ctaMan from "assets/images/psp/inlineCTA.jpg";

import "./InlineCTA.scss";
import Container from "components/core/Page/Container";

const InlineCTA = ({
	storageType,
	subheading,
	searchPlaceholder,
	searchButtonText,
	image,
	imageAltText,
	background
}) => {
	const location = useSelector((state) => state.user.geolocation);
	const city = location?.city || "";
	const state = location?.region || "";

	const getTitle = () => {
		if (storageType === "Electricity") {
			return `Find Storage Units with Electricity in ${city}, ${state}`;
		}
		if (storageType === "Truck") {
			return `Find Storage Units with Free Truck Rentals in ${city}, ${state}`;
		}
		return `Find ${storageType} Storage Units in ${city}, ${state}`;
	};

	return (
		<section className={classnames("inline-cta-section", background)}>
			<Container>
				<div className={classnames("inline-cta")}>
					<div className="inline-cta__content">
						<div className="inline-cta__content__text">
							<H2
								size="huge"
								weight="bold"
								color="darkBlue"
								className="inline-cta__content__text__heading"
							>
								{getTitle()}
							</H2>
							<Paragraph
								size="medium"
								weight="regular"
								color="lightGray"
								className="inline-cta__content__text__subheading"
							>
								{subheading}
							</Paragraph>
						</div>
						<div className="inline-cta__content__search">
							<SearchBar
								id="inline-cta-search-bar"
								label={searchPlaceholder}
								buttonText={searchButtonText}
								theme="plainBlue"
								buttonClassName="inline-cta__content__search__button"
							/>
						</div>
					</div>
					<div className="inline-cta__visual">
						<Image
							src={image}
							alt={imageAltText ?? "inline_cta_image"}
						/>
					</div>
				</div>
			</Container>
		</section>
	);
};

InlineCTA.propTypes = {
	subheading: PropTypes.string,
	searchPlaceholder: PropTypes.string,
	searchButtonText: PropTypes.string,
	image: PropTypes.string,
	imageAltText: PropTypes.string,
	background: PropTypes.oneOf(["light-blue", "white"]),
	storageType: PropTypes.string.isRequired
};

InlineCTA.defaultProps = {
	subheading: "Make a free reservation in minutes!",
	searchPlaceholder: "Search by city, state, or zip...",
	searchButtonText: "Find Storage",
	background: "white",
	image: ctaMan
};

export default InlineCTA;
